module.exports = __webpack_public_path__ + "img/signup.7e770d57.png";